import { render } from "./Privacy.vue?vue&type=template&id=54f7e6e2&scoped=true&ts=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"

import "./Privacy.vue?vue&type=style&index=0&id=54f7e6e2&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f7e6e2"]])

export default __exports__